import type { ReactNode } from "react";
import { motion } from "framer-motion";

export function FileIcon(): ReactNode {
  return (
    <svg
      width="28"
      height="34"
      viewBox="0 0 28 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M2 1h16l8 8v23a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2Z"
        style={{ fill: "var(--color-accent-subtle)", stroke: "var(--color-accent)" }}
        strokeWidth="1.5"
      />
      <path d="M18 1v8h8" style={{ stroke: "var(--color-accent)" }} strokeWidth="1.5" fill="none" />
      <text
        x="14"
        y="24"
        textAnchor="middle"
        fontSize="8"
        fontWeight="600"
        style={{ fill: "var(--color-accent)" }}
        fontFamily="var(--font-sans)"
      >
        OFX
      </text>
    </svg>
  );
}

export function CheckmarkIcon(): ReactNode {
  return (
    <motion.svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ type: "spring", stiffness: 300, damping: 20, delay: 0.1 }}
    >
      <circle
        cx="16"
        cy="16"
        r="15"
        style={{ fill: "var(--color-success-bg)", stroke: "var(--color-success)" }}
        strokeWidth="1.5"
      />
      <motion.path
        d="M9 16l5 5 9-10"
        style={{ stroke: "var(--color-success)" }}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 0.4, delay: 0.2, ease: "easeOut" }}
      />
    </motion.svg>
  );
}
